export default Object.freeze({
  Mixed: 1,
  UserAndPassword: 2,
  Office365: 3,
  Google: 4,
  Automy: 5,
});
